import styled from "styled-components";

import { home } from "@routes/DashboardRoute/Home/tokens";

/**
 * The migration dialog, built on the web design system (homeTokens / futuremoney-home-spec).
 *
 * Mobile shows these as bottom sheets; on web the same content is a centred dialog, which is the
 * idiom the rest of the dashboard's modals use. The surface re-declares the --hm-* variables itself
 * (see Surface usage) because the modal is portalled to document.body, outside the page that
 * normally declares them.
 */
export const Surface = styled.div`
  position: relative;
  width: min(440px, calc(100vw - 32px));
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  box-sizing: border-box;
  padding: 40px 28px 28px;
  border-radius: ${home.radius}px;
  border: 1px solid ${home.line10};
  font-family: ${home.sans};
  color: ${home.ink};
  /* The warm glow the design carries at the top of the sheet, in the spec's copper. */
  background:
    radial-gradient(120% 70% at 50% 0%, rgba(224, 155, 124, 0.22), transparent 70%),
    ${home.cardSolid};
`;

export const Stack = styled.div<{ $gap?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ $gap }) => $gap ?? 24}px;
`;

export const Logo = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
`;

export const Body = styled.p`
  align-self: stretch;
  margin: 0;
  font-size: 14px;
  line-height: 21px;
  color: ${home.ink72};
`;

export const Note = styled.p`
  align-self: stretch;
  margin: 0;
  font-size: 13px;
  line-height: 19px;
  color: ${home.ink62};
`;

export const Clickwrap = styled.p`
  margin: 0;
  padding: 0 12px;
  font-size: 11.5px;
  line-height: 16px;
  text-align: center;
  color: ${home.ink50};
`;

export const ErrorText = styled.p`
  margin: 0;
  font-size: 13px;
  text-align: center;
  color: ${home.error};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  margin-top: 32px;
`;

/** Low-emphasis secondary action: the spec allows one filled button per surface. */
export const TextAction = styled.button`
  align-self: center;
  padding: 4px 8px;
  border: none;
  background: transparent;
  font-family: ${home.sans};
  font-size: 14px;
  font-weight: 500;
  color: ${home.ink62};
  cursor: pointer;
  transition: color 160ms ease;

  &:hover {
    color: ${home.ink};
  }
`;
